import type { EmailStatus } from "@/types/email";

type EmailStatusBannerProps = {
  status: EmailStatus | null;
};

export default function EmailStatusBanner({ status }: EmailStatusBannerProps) {
  if (!status || status.status === "connected") {
    return null;
  }
  const message =
    status.status === "not_configured"
      ? "User email not yet synced. Sync Email with IMAP to enable inbox features."
      : status.message || "Email integration encountered an issue. Sync Email with IMAP to reconnect.";
  return (
    <div className="aa-glass-card rounded-2xl border-warning/40 bg-warning/10 px-4 py-3 text-sm text-foreground">
      {message}
    </div>
  );
}
